import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { getEmployeeProfiles } from '../queries/employeeProfiles.query';
import { getJobDetails, applyJob, selectedcompanyInfo, getJobProfileInfo, addEnquiryMutation, addAppliedMessageMutation, addTalentEnquiryMutation } from '../queries/jobsinfo.query';
import { ToastService } from 'src/app/core/toast.service';

@Injectable({
  providedIn: 'root'
})

export class JobInfo {

  constructor(private apollo: Apollo, private toast: ToastService) { }

  //Getting All Employees  
  gettingJobDetails(jobPost_bids): Observable<any> {
    return this.apollo.use("external").subscribe({
      query: getJobDetails,
      variables: {
        "id": jobPost_bids
      }
    }).pipe(pluck('data', 'jobs'));

  }

  //Apply Job
  async applyJob(applyJobobject): Promise<any> {    

    try {
      await this.apollo.use("external").mutate({
        mutation: applyJob,
        variables: { applyJobobject }
      }).pipe(pluck('data', 'insert_jobapplicants')).toPromise();
      this.toast.openSnackBar(
        'Applied successfully'
      );
      return true
    } catch (err) {
      console.log(err);
      this.toast.openSnackBar('You Failed To add');
      return false
    }

  }

    addAppliedMessage(message: any): Promise<any> {
    
    return this.apollo.mutate({
      mutation: addAppliedMessageMutation,
      variables: {
        object: message
      }
    }).toPromise();
  }

  getSelectedComapnyName(loginid: string) {
    return this.apollo.query({
      query: selectedcompanyInfo,
      variables: { loginid: loginid }
    }).pipe(pluck('data', 'directories'));
  }

   getJobProfileData(id:any): Observable<any> {
      return this.apollo.use("external").subscribe({
        query: getJobProfileInfo,
        variables: {
          "id": id
        }
      }).pipe(pluck('data', 'job_profiles'));
    }

    EnquiryMessage(Enquiry: any): Promise<any> {
        
        return this.apollo.mutate({
          mutation: addEnquiryMutation,
          variables: {
            object: Enquiry
          }
        }).toPromise();
      }


  TalentEnquiry(Enquiry: any): Promise<any> {

    return this.apollo.mutate({
      mutation: addTalentEnquiryMutation,
      variables: {
        object: Enquiry
      }
    }).toPromise();
  }
}